'use client';

import type { ReactNode } from 'react';
import { useState } from 'react';

import { type Messages, setupI18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';

type Props = {
  children: ReactNode;
  initialLocale: string;
  initialMessages: Messages;
};

function LinguiClientProvider({
  children,
  initialLocale,
  initialMessages
}: Props) {
  const [i18n] = useState(() =>
    setupI18n({
      locale: initialLocale,
      messages: { [initialLocale]: initialMessages }
    })
  );

  return <I18nProvider i18n={i18n}>{children}</I18nProvider>;
}

export { LinguiClientProvider };
